import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import nl from './nl.json'
import pt from './pt.json'
import uk from './uk.json'
import zh from './zh.json'
import { messages } from '@scantrust/st-gallery'

import countriesDe from './shared/countries/de.json'
import countriesEn from './shared/countries/en.json'
import countriesEs from './shared/countries/es.json'
import countriesFr from './shared/countries/fr.json'
import countriesIt from './shared/countries/it.json'
import countriesNl from './shared/countries/nl.json'
import countriesPt from './shared/countries/pt.json'
import countriesUk from './shared/countries/uk.json'

export default {
  messages: {
    en: {
      ...en,
      ...messages.en,
      ...countriesEn
    },
    fr: {
      ...fr,
      ...messages.fr,
      ...countriesFr
    },
    de: {
      ...de,
      ...messages.de,
      ...countriesDe
    },
    es: {
      ...es,
      ...messages.es,
      ...countriesEs
    },
    it: {
      ...it,
      ...messages.it,
      ...countriesIt
    },
    nl: {
      ...nl,
      ...messages.nl,
      ...countriesNl
    },
    pt: {
      ...pt,
      // change later
      ...messages.en,
      ...countriesPt
    },
    uk: {
      ...uk,
      ...messages.uk,
      ...countriesUk
    },
    zh: {
      ...zh,
      ...messages.zh
    }
  }
}
